import React from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
//import GetAllFormFields from '../../../../components/_utils/formUtils'
import {FormUtils as GetAllFormFields} from 'sz-react-utils'

import {Button, Form, notification} from 'antd'

import _ from 'lodash'
import {hideLoader, showLoader} from '../../../../modules/actions'
import Request from '../../../../request'
import {connect} from 'react-redux'

let countryId = null

@Form.create()
class VisaCategory extends React.Component {
    state = {
        loading: false,
        arr: [],
        inputTypes: [
            {
                fields: [
                    {
                        label: 'Visa Category',
                        key: 'categories',
                        required: true
                    }
                ]
            }
        ]
    }

    constructor(props) {
        super(props)
    }

    handleSubmit = e => {
        const {dispatch, form} = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)

                if (countryId) {
                    values = {...values, _id: countryId}

                    dispatch(showLoader())

                    let x = await Request.updateVisaCategories(values)

                    dispatch(hideLoader())

                    if (!x.error) {
                        notification.success({
                            message: 'Success',
                            description: x.msg
                        })
                    } else {
                        notification.error({
                            message: 'Error Saving',
                            description: x.msg
                        })
                    }
                } else {
                    dispatch(showLoader())
                    let x = await Request.addVisaCategories(values)
                    dispatch(hideLoader())
                    if (!x.error) {
                        notification.success({
                            message: 'Success',
                            description: x.msg
                        })

                        form.resetFields()
                    } else {
                        notification.error({
                            message: 'Error Saving',
                            description: x.msg
                        })
                    }
                }
            }
        })
    }

    componentDidMount() {
        let searchParams = new URLSearchParams(this.props.search)
        countryId = searchParams.get('id')

        if (countryId) {
            this.setState({showFiles: 1})
            this.setFormValues(countryId)
        }
    }

    setFormValues = async countryId => {
        try {
            let {doc} = await Request.getVisaCategories(countryId)

            if (doc) {
                let tempObj = {}

                let inputTypes = this.state.inputTypes

                _.each(inputTypes, (val, kk) => {
                    if (kk == '0') {
                        _.each(inputTypes[0].fields, (v, k) => {
                            tempObj[v.key] = doc[v.key]
                        })
                    }
                })

                this.props.form.setFieldsValue(tempObj)
            }
        } catch (e) {
            console.log(e)
        }
    }

    render() {
        const {
            form: {getFieldDecorator, getFieldValue}
        } = this.props

        return (
            <PageHeaderWrapper title={'Visa Category'}>
                <div style={{background: 'white'}}>
                    <div style={{padding: 20}}>
                        <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                            {this.state.inputTypes.map((itype, key) => {
                                return (
                                    <div key={key + 1}>
                                        <GetAllFormFields
                                            inputSchema={this.state.inputTypes[key]}
                                            getFieldDecorator={getFieldDecorator}
                                        />
                                    </div>
                                )
                            })}
                            <div style={{textAlign: 'center'}}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={this.props.loading}>
                                    SAVE
                                </Button>
                            </div>
                        </Form>
                    </div>
                </div>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search
})

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VisaCategory)
